import { render, staticRenderFns } from "./Firebase.vue?vue&type=template&id=78eb52fc&"
import script from "./Firebase.vue?vue&type=script&lang=js&"
export * from "./Firebase.vue?vue&type=script&lang=js&"
import style0 from "./Firebase.vue?vue&type=style&index=0&id=78eb52fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports